export default "__VITE_ASSET__DxjF$Gul__"